<div class="container">
  <div class="row m-auto">
    <div class="d-flex flex-lg-row flex-column">
      <div
        class="d-flex flex-grow-1 order-0"
        [ngClass]="{
          'order-lg-0': position === 'left',
          'order-lg-1': position !== 'left'
        }">
        <label class="m-auto">
          <img [src]="image" alt="" />
        </label>
      </div>
      <div
        class="d-flex flex-grow-1 mt-5 mt-lg-0 order-2"
        [ngClass]="{
          'order-lg-0': position !== 'left',
          'order-lg-1': position === 'left',
          'mr-5': position !== 'left'
        }">
        <div class="ps-5 m-auto">
          <h2 class="font-weight-bolder">{{ title }}</h2>
          <p>{{ text }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
